import React, { memo } from 'react'

import { Asable } from '../../../../types/asable'
import * as Styled from './styles'

type NavListSeparatorProps = Asable

export const NavListSeparator = memo((props: NavListSeparatorProps) => <Styled.Separator {...props} />)
